export enum AnswerStatus {
  NOT_REVIEWED,
  REJECTED,
  ACCEPTED,
  FLAGGED,
}
